import { useState } from 'react';
import { useLang } from '@/app/hooks/useLang';
import { getYoutubeId } from '@/app/lib/youtube';

type YoutubeEmbedProps = {
  url: string;
  title: string;
  poster?: string;
  width?: number;
  height?: number;
};

export function YoutubeEmbed({ url, title, poster, width = 480, height = 360 }: YoutubeEmbedProps) {
  const { t } = useLang();
  const id = getYoutubeId(url);
  const [active, setActive] = useState(false);
  const viewLabel = t('action.viewFootage');

  if (!id) return null;

  return (
    <div>
      <div className="aspect-video overflow-hidden">
        {active ? (
          <iframe
            src={`https://www.youtube.com/embed/${id}?autoplay=1`}
            title={title}
            className="h-full w-full"
            loading="lazy"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        ) : (
          <button
            type="button"
            onClick={() => setActive(true)}
            className="relative block h-full w-full"
            aria-label={`${viewLabel}: ${title}`}
          >
            <img
              src={poster ?? `https://i.ytimg.com/vi/${id}/hqdefault.jpg`}
              alt=""
              width={width}
              height={height}
              className="h-full w-full object-cover"
              loading="lazy"
              decoding="async"
            />
            <span className="absolute inset-0 flex items-center justify-center bg-black/45 text-sm uppercase tracking-[0.3em]">
              {viewLabel}
            </span>
          </button>
        )}
      </div>
      <p className="mt-2 text-xs dim">{title}</p>
    </div>
  );
}
